import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import AppFa from './AppFa';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('homatec_bookingbox') as HTMLElement
);

const htmlTag: HTMLElement = document.getElementsByTagName('html')[0];
root.render(
  <React.StrictMode>
    {
      htmlTag.getAttribute('lang') == 'fa-IR' ? <AppFa /> : <App />
    }
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
